<template>
  <!-- <div
    class="w-367px h-full bg-contain bg-no-repeat absolute component-container transition-all z-998 top-0 right-calc[-390%]"
  > -->
  <div class="h-full">
    <!-- <cardTitle title="摄像头信息" class="mb-10px" /> -->
    <div class="border-2px p-10px rounded-5px border-[#45f2eb33] mt-10px">
      <div class="w-full flex text-hex-DCDEDE">
        <span class="w-100px truncate text-right text-14px !leading-30px">设备名称：</span>
        <span class="truncate text-white font-bold text-14px !leading-30px">{{
          currentRelationData.cameraAlias
        }}</span>
      </div>
      <div class="w-full flex text-hex-DCDEDE">
        <span class="w-100px truncate text-right text-14px !leading-30px">制造商：</span>
        <span class="truncate text-white font-bold text-14px !leading-30px">{{
          currentRelationData.manufacturer
        }}</span>
      </div>
      <div class="w-full flex text-hex-DCDEDE">
        <span class="w-100px truncate text-right text-14px !leading-30px">型号：</span>
        <span class="truncate text-white font-bold text-14px !leading-30px">{{
          currentRelationData.modelNumber
        }}</span>
      </div>
      <div class="w-full flex text-hex-DCDEDE">
        <span class="w-100px truncate text-right text-14px !leading-30px">序列号：</span>
        <span class="truncate w-200px text-white font-bold text-14px !leading-30px">{{
          currentRelationData.serialNumber
        }}</span>
      </div>
      <div class="w-full flex text-hex-DCDEDE">
        <span class="w-100px truncate text-right inline-block text-14px !leading-30px">状态：</span>
        <span class="truncate text-white font-bold text-14px !leading-30px">{{
          currentRelationData.onlineStatus
        }}</span>
      </div>
      <el-button
        class="!mt-16px !ml-40px btn-example"
        @click="openDialog"
        v-if="currentRelationData.onlineStatus === '在线'"
        >实时画面</el-button
      >
    </div>
    <cardTitle title="报警信息" class="mb-10px mt-16px" />
    <el-row type="flex" align="middle" class="mb-5px w-full">
      <el-col :span="16" class="text-12px">
        <el-date-picker
          size="small"
          popper-class="visualization-picker-popper"
          style="width:100%"
          v-model="filterPlan.dateRange[0]"
          :picker-options="datePickOption"
          type="datetime"
          placeholder="选择开始时间"
        ></el-date-picker>
      </el-col>
      <el-col :span="16" class="text-12px ml-12px">
        <el-date-picker
          size="small"
          popper-class="visualization-picker-popper"
          style="width:100%"
          v-model="filterPlan.dateRange[1]"
          :picker-options="datePickOption"
          type="datetime"
          placeholder="选择结束时间"
        ></el-date-picker>
      </el-col>
      <el-col :span="8" class="ml-12px">
        <el-button type="primary" size="small" @click="getTableList">
          <i class="iconfont el-icon-search text-18px"></i>
        </el-button>
      </el-col>
    </el-row>
    <el-table :data="tableData" height="calc(100% - 330px)" class="w-full text-12px">
      <el-table-column
        width="120"
        prop="algorithmName"
        show-overflow-tooltip
        label="事件项"
        align="center"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="currentAlertDegreeName"
        show-overflow-tooltip
        label="当前等级"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="time"
        show-overflow-tooltip
        label="发生时间"
      ></el-table-column>
      <el-table-column align="center" label="操作" width="50">
        <template #default="{row}">
          <div @click.stop="openMessage(row)" class="cursor-pointer !text-hex-4095e5">查看</div>
        </template>
      </el-table-column>
    </el-table>
    <AlarmDetail
      v-if="alarmDetailVisible"
      :visible.sync="alarmDetailVisible"
      :showMessage="showMessage"
      :monitorData="monitorData"
    ></AlarmDetail>
  </div>
</template>

<script>
import { CameraManagementApi } from '@wiz-api/haiguang'
import cardTitle from '@/components/cockpit/CardTitle'

const cameraManagement = new CameraManagementApi()

// 报警详情
const AlarmDetail = () => {
  return import('../../tool/AlarmDetail')
}

export default {
  components: {
    cardTitle,
    AlarmDetail,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // 当前的摄像头信息
      currentRelationData: {},
      // 报警信息的列表
      tableData: [],
      // 时间选择器对应的数据
      filterPlan: {
        dateRange: [],
        checkDate: '',
      },
      // 弹出框的显隐
      alarmDetailVisible: false,
      // 是否是展示详细信息的弹出框
      showMessage: false,
      // 传给弹出框的摄像头相关信息
      monitorData: {},
    }
  },
  methods: {
    // 时间允许选择范围
    datePickOption() {
      return {
        // disabledDate: (time) => {
        //   if (this.filterPlan.dateRange[0] && this.filterPlan.dateRange[1]) {
        //     return (
        //       time.getTime() < moment(this.filterPlan.dateRange[0]).valueOf() ||
        //       time.getTime() < moment(this.filterPlan.dateRange[1]).valueOf()
        //     )
        //   }
        //   return true
        // },
      }
    },
    // // 切换时间触发的事件
    // handleChange(value) {
    //   if (this.filterPlan.dateRange[0] && this.filterPlan.dateRange[1]) {
    //     this.getTableList()
    //   }
    // },
    // 点击开启监控弹框
    openDialog() {
      this.alarmDetailVisible = true
      this.showMessage = false
      this.monitorData = { ...this.currentRelationData }
    },
    // 点击开启监控附带监控信息的弹框
    openMessage(row) {
      // console.log('时间范围', moment(this.filterPlan.dateRange[0]).format('YYYY-MM-DD HH:mm:ss'))
      this.alarmDetailVisible = true
      this.showMessage = true
      this.monitorData = { ...row }
    },
    // 获取报警信息列表
    async getTableList() {
      const [err, totalData, bodyData] = await cameraManagement.getCameraAlarmPage({
        body: {
          // deviceAlias: '',
          deviceAlias: this.currentRelationData.cameraAlias,
          startTime: moment(this.filterPlan.dateRange[0]).format('YYYY-MM-DD HH:mm:ss') || null,
          endTime: moment(this.filterPlan.dateRange[1]).format('YYYY-MM-DD HH:mm:ss') || null,
          current: 1,
          size: 99,
        },
      })
      const res = bodyData.response.body
      // console.log(res, '获取报警信息列表')
      if (res && res.code === 200 && res.data) {
        this.tableData = res.data.records || []
      }
    },
  },
  watch: {
    transferProps: {
      handler(val) {
        this.currentRelationData = { ...val.videoRow }
      },
      immediate: true,
    },
  },
  created() {
    // console.log(this.transferProps.videoRow, '传递过来的状态为：')
    this.filterPlan.dateRange[0] = `${new Date().getFullYear()}-${new Date().getMonth() +
      1}-${new Date().getDate()} 00:00:00`
    this.filterPlan.dateRange[1] = `${new Date().getFullYear()}-${new Date().getMonth() +
      1}-${new Date().getDate()} 23:59:59`
    this.getTableList()
  },
  beforeDestroy() {
    this.alarmDetailVisible = false
  },
}
</script>

<style>
.btn-example {
  background: var(--cockpitTableHeaderTrBg) !important;
  background-blend-mode: var(--cockpitTableHeaderTrBgBlendMode);
  color: white !important;
}
.component-container {
  background-image: var(--containerBgImg);
  background-size: 100% 100%;
  padding: var(--containerPadding);
}
</style>
